import nodeSourceFactory from "../nodeOrEdgeSourceDataHandling/nodeSourceFactory";
import addOrUpdateNodeLabel from "../nodeRendering/addOrUpdateNodeLabel";
export default (graphComponentRef, documentObject, nodeSource, layout) => {
    var _a;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph))
        return undefined;
    const tag = nodeSourceFactory({ ...nodeSource, DocumentObject: documentObject });
    const node = layout
        ? graphComponentRef.current.graph.createNode({ tag, layout })
        : graphComponentRef.current.graph.createNode({ tag });
    addOrUpdateNodeLabel(graphComponentRef, node, documentObject);
    return node;
};
